var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"ex_avatar",attrs:{"color":"#F9F5FF","size":_vm.sizeVal}},[(_vm.picture)?_c('img',{attrs:{"src":_vm.picture}}):_c('span',{staticClass:"text",class:{
    'text-small': _vm.size == 'small',
    'text-medium': _vm.size == 'medium',
    'text-large': _vm.size == 'large',
  }},[_vm._v(_vm._s(_vm.initialsVal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }